module.exports = __webpack_public_path__ + "static/fast-track-calendar-11033f6b9f3755b934c3db8ee29b529b.jpg";